"use client";

import type React from "react";

import { useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../dashboard/company-dashboard/ui/card";
import { Label } from "../dashboard/company-dashboard/ui/label";
import { Input } from "../dashboard/company-dashboard/ui/input";
import { Button } from "../dashboard/company-dashboard/ui/button";
import { Textarea } from "../dashboard/company-dashboard/ui/textarea";
import { useAppContext } from "../../shared/functions/Context";
import { Badge } from "../dashboard/company-dashboard/ui/badge";

export default function EmailIntegrationDemo() {
  const { api, store } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState<string>("");

  const handleSendEmail = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    setResult("");

    const formData = new FormData(e.currentTarget);
    const to = formData.get("to") as string;
    const subject = formData.get("subject") as string;
    const message = formData.get("message") as string;

    try {
      const response = await api.mail.sendMail(
        [to],
        "noreply@nkurenkuru-tc.com",[],
        subject,
        message
      );
      setResult(`✅ Email sent successfully: ${response.message}`);
    } catch (error) {
      setResult(`❌ Failed to send email: ${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card className="w-full max-w-md mx-auto">
      <CardHeader>
        <CardTitle>Cross-Project Email Demo</CardTitle>
        <CardDescription>
          Send emails using Firebase functions from a different project
        </CardDescription>
        <div className="flex gap-2">
          <Badge variant="outline">Main App: nkurenkuru-36978</Badge>
          <Badge variant="secondary">Email API: nkurenkuru-town-council</Badge>
        </div>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSendEmail} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="demo-to">To Email</Label>
            <Input
              id="demo-to"
              name="to"
              type="email"
              placeholder="recipient@example.com"
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="demo-subject">Subject</Label>
            <Input
              id="demo-subject"
              name="subject"
              placeholder="Test from cross-project integration"
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="demo-message">Message</Label>
            <Textarea
              id="demo-message"
              name="message"
              placeholder="This email was sent using Firebase functions from a different project!"
              rows={3}
              required
            />
          </div>
          <Button type="submit" disabled={isLoading} className="w-full">
            {isLoading ? "Sending..." : "Send Email"}
          </Button>
        </form>

        {result && (
          <div className="mt-4 p-3 bg-muted rounded-md">
            <p className="text-sm">{result}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
